const RichTextEditorStyles = {
    a: {
        color: '#ff7200',
        fontWeight: 600,
    },
    p: {
        marginBottom: '1.5rem',
        '&:last-child': {
            marginBottom: 0,
        },
    },
    h1: {
        fontSize: '54px',
        lineHeight: 1.1,
        marginBottom: '28px',
        '@media (max-width: 768px)': {
            fontSize: '48px',
        },
    },
    h2: {
        fontSize: '36px',
        lineHeight: 1,
        color: '#2b3b48',
        marginBottom: '15px',
        marginTop: '1em',
        '&:first-of-type': {
            marginTop: 0,
        },
        '@media (min-width: 769px)': {
            lineHeight: 1.33,
        },
    },
    h3: {
        fontSize: '18px',
        letterSpacing: '2.57px',
        lineHeight: '22px',
        color: '#ff7400',
        marginBottom: '7px',
        marginTop: '1em',
        '&:first-of-type': {
            marginTop: 0,
        },
        '@media (max-width: 768px)': {
            fontWeight: 600,
        },
    },
    h4: {
        fontSize: '24px',
        fontWeight: 600,
        lineHeight: '33px',
        color: ' #2b3a49',
        letterSpacing: '0.34px',
    },
    ul: {
        marginBottom: '1em',
    },
    li: {
        listStylePosition: 'outside',
        listStyleType: 'disc',
        marginLeft: '1.5rem',
        marginBottom: '0.5rem',
    },
    hr: {
        marginBottom: '1.5rem',
    },
    blockquote: {
        fontSize: '1.125rem',
        lineHeight: '1.75rem',
        color: 'rgb(255, 102, 0)',
        marginTop: '2.5rem',
        marginBottom: '2.5rem',
        '@media (min-width: 1024px)': {
            fontSize: '36px',
            lineHeight: '2.5rem',
            marginTop: '5rem',
            marginBottom: '5rem',
        },
    },
    table: {
        border: '1px solid #dddddd',
        borderCollapse: 'collapse',
    },
    th: {
        border: '1px solid #dddddd',
    },
    td: {
        border: '1px solid #dddddd',
        padding: '0.5rem',
    },
};

export default RichTextEditorStyles;
